import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { useState } from "react";
import InvoiceForm from "@/v2/components/pages/invoice/Form";
import { EditIcon } from "lucide-react";

export default function EditInvoice({
    id,
    isInside = false,
    type,
}: {
    id: string;
    isInside?: boolean;
    type: "PAYABLE_INVOICE" | "RECEIVABLE_INVOICE";
}) {
    const [open, setOpen] = useState(false);
    return (
        <Dialog open={open} onOpenChange={(value) => setOpen(value)}>
            <DialogTrigger asChild>
                <Button
                    size={"sm"}
                    variant={"outline"}
                    className="flex items-center gap-2"
                >
                    <EditIcon className="h-4 w-4" />
                    {isInside && "Edit"}
                </Button>
            </DialogTrigger>
            <DialogContent className="min-w-[700px]">
                <DialogHeader>
                    <DialogTitle className="text-2xl font-semibold tracking-tight">
                        Edit{" "}
                        {type === "PAYABLE_INVOICE" ? "Payable" : "Receivable"}{" "}
                        Invoice Record
                    </DialogTitle>
                    <DialogDescription className="text-sm text-muted-foreground">
                        Fill in the details to edit a new{" "}
                        {type === "PAYABLE_INVOICE" ? "payable" : "receivable"}{" "}
                        invoice record
                    </DialogDescription>
                </DialogHeader>
                <InvoiceForm
                    id={id}
                    closeOnSave={() => setOpen(false)}
                    type={type}
                />
            </DialogContent>
        </Dialog>
    );
}
